import {
  type Component,
  For,
  Show,
  Switch,
  Match,
  createSignal,
} from "solid-js";
import { useSessionContext, useShopContext } from "~/utils/contexts";
import { ListConfigProductDetail } from "../ShopContextProvider";
import { Icon } from "solid-heroicons";
import { eyeSlash, lockClosed } from "solid-heroicons/outline";
import { eye } from "solid-heroicons/solid";
import { ProductImage } from "~/components/product";
import { PT } from "~/utils/products";
import { productImages } from "~/components/product/product-page/utils";

export const ListItemConfiguration: Component<{
  type: "moulding" | "galleryFrame" | "photoFrame" | "mirror" | "contract";
  onClose: () => void;
}> = (props) => {
  const { shopConfig, setShopConfig } = useShopContext();
  const { isPartner } = useSessionContext();
  const displayType = () => {
    switch (props.type) {
      case PT.PHOTOFRAME:
      case PT.GALLERYFRAME:
      case PT.MOULDING:
        return props.type;
      default:
        return PT.MOULDING;
    }
  };
  const [activeType, setActiveType] = createSignal<
    "moulding" | "galleryFrame" | "photoFrame" | "mirror" | "contract"
  >(displayType());


  const DetailButton: Component<{
    column: number;
    index: number;
    detail: ListConfigProductDetail;
  }> = (props) => {
    const toggleEnabled = () => {
      setShopConfig(
        "listConfig",
        "options",
        props.column,
        props.index,
        "enabled",
        !shopConfig.listConfig.options[props.column][props.index].enabled
      );
    };

    return (
      <div
        class={`${
          props.detail.enabled
            ? "bg-white text-roma-dark-grey"
            : "bg-roma-grey text-roma-medium-grey"
        } text-sm border rounded-md flex flex-col items-center pl-1`}
      >
        <div class="flex items-center w-full">
          {/* <Show when={false}>
            <div class="flex items-center justify-center">
              <Icon path={bars_2} class="w-5 h-5" />
            </div>
          </Show> */}
          <span
            class={`grow pl-1 ${props.detail.enabled ? "" : "line-through"}`}
          >
            {props.detail.label}
          </span>
          <Show when={!isPartner() && props.detail.type === "price"}>
            <Icon path={lockClosed} class="w-5 h-5 mr-1" />
          </Show>
          <div class="border-l">
            <button
              disabled={!isPartner() && props.detail.type === "price"}
              onClick={toggleEnabled}
              class="flex items-center justify-center px-1 disabled:cursor-not-allowed"
            >
              <Icon
                path={props.detail.enabled ? eye : eyeSlash}
                class="w-5 h-5"
              />
            </button>
          </div>
        </div>
        <Switch>
          <Match when={props.detail.type === "availableAs"}>
            <div class="w-full border-t pt-2 p-1 flex flex-wrap gap-1">
              <div class="w-7 h-7 border aspect-square bg-roma-grey" />
              <div class="w-7 h-7 border aspect-square bg-roma-grey" />
              <div class="w-7 h-7 border aspect-square bg-roma-grey" />
              <div class="w-7 h-7 border aspect-square bg-roma-grey" />
            </div>
          </Match>
          <Match when={props.detail.type === "colors"}>
            <div class="w-full border-t pt-2 p-1 flex flex-wrap gap-1">
              <div class="w-5 h-5 border aspect-square bg-roma-grey rounded-full" />
              <div class="w-5 h-5 border aspect-square bg-roma-grey rounded-full" />
              <div class="w-5 h-5 border aspect-square bg-roma-grey rounded-full" />
              <div class="w-5 h-5 border aspect-square bg-roma-grey rounded-full" />
            </div>
          </Match>
        </Switch>
      </div>
    );
  };

  return (
    <div class="bg-faint-blue border border-gray-300  p-5 flex gap-3 shadow-sm">
      <div class="flex gap-1">
        <div class="w-[220px] h-[220px] shrink-0 aspect-square p-2 rounded-l-lg relative">
          <ProductImage
            src={
              productImages("2032003", activeType())[
                shopConfig.listConfig.mainImages[activeType()]
              ]
            }
            layout="fullWidth"
            aspectRatio={1}
            quality={85}
            breakpoints={[300, 440]}
          />
          <div class="absolute inset-0 backdrop-blur-[2px] flex flex-col justify-end items-end">
            <p class="bg-white p-1 rounded-md border text-sm absolute top-0">
              Select Default Image
            </p>
          </div>
        </div>
        <div class="flex flex-col justify-center gap-1 w-9 shrink-0">
          <For each={productImages("2032003", activeType())}>
            {(item, i) => (
              <button
                class="aspect-square border w-9  "
                classList={{
                  "border-gray-400":
                    shopConfig.listConfig.mainImages[activeType()] === i(),
                }}
                onClick={() =>
                  setShopConfig("listConfig", "mainImages", activeType(), i())
                }
              >
                <ProductImage
                  class="bg-white p-0.5"
                  src={item}
                  layout="fullWidth"
                  aspectRatio={1}
                  quality={85}
                  breakpoints={[80]}
                />
              </button>
            )}
          </For>
        </div>
      </div>
      <div class="border-l border-gray-300 pl-3 flex flex-col w-full text-sm">
        <div class="text-sm flex items-center  border-b border-gray-400 pb-2 gap-1">
          <button
            onClick={() => setActiveType("moulding")}
            class={`border rounded-md px-2 py-1 active:translate-y-0.5 ${
              activeType() === "moulding"
                ? "bg-white border-gray-300 text-roma-dark-grey"
                : "bg-roma-grey text-roma-medium-grey"
            }`}
          >
            Moulding
          </button>
          <button
            onClick={() => setActiveType("photoFrame")}
            class={`border rounded-md px-2 py-1 active:translate-y-0.5 ${
              activeType() === "photoFrame"
                ? "bg-white border-gray-300 text-roma-dark-grey"
                : "bg-roma-grey text-roma-medium-grey"
            }`}
          >
            Photo Frame
          </button>
          <button
            onClick={() => setActiveType("galleryFrame")}
            class={`border rounded-md px-2 py-1 active:translate-y-0.5 ${
              activeType() === "galleryFrame"
                ? "bg-white border-gray-300 text-roma-dark-grey"
                : "bg-roma-grey text-roma-medium-grey"
            }`}
          >
            Gallery Frame
          </button>
          <button
            onClick={() => props.onClose()}
            class="ml-auto rounded-md bg-roma-blue text-white px-2 py-1"
          >
            Close
          </button>
        </div>
        <div class=" grid grid-cols-[1fr_1fr] gap-1 w-full mt-2">
          <For each={shopConfig.listConfig.options}>
            {(group, column) => (
              <div class="w-full flex flex-col gap-y-1 child:py-0.5">
                <For each={group}>
                  {(item, i) => (
                    <DetailButton column={column()} index={i()} detail={item} />
                  )}
                </For>
              </div>
            )}
          </For>
        </div>
      </div>
    </div>
  );
};
